import * as React from 'react';
import * as QueryString from 'query-string';

interface ILabSimCompanyLinkProps {

}

interface ILabSimCompanyLinkState {
    loading: boolean;
    searching: boolean;
    error?: string;
    showCreateCampus: boolean;
    completed: boolean;
    completedMessage?: string;

    search?: string;
    hubSpotData?: IInstitutionData;
    labSimId?: string;
    institutions?: Array<IInstitutionData>;
}

interface IInitInstitutionData {
    hubSpotData: IInstitutionData;
    labSimId: string;
    error: string;
}

interface IInstitutionData {
    version: number;
    id: string;
    name: string;
    institutionType: string;
    address: string;
    city: string;
    stateOrProvince: string;
    postalCode: string;
    country: string;
}

interface IInstitutionsResponse {
    institutions: Array<IInstitutionData>;
    error: string;
}

interface ILinkResponse {
    error: string;
}

export default class LabSimCompanyLink extends React.PureComponent<ILabSimCompanyLinkProps, ILabSimCompanyLinkState> {
    constructor(props: ILabSimCompanyLinkProps) {
        super(props);
        this.state = { searching: false, loading: true, showCreateCampus: false, completed: false };
    }

    cancelForm() {
        window.parent.postMessage(JSON.stringify({ "action": "CANCEL" }), "*");
    }

    closeForm() {
        window.parent.postMessage(JSON.stringify({ "action": "DONE" }), "*");
    }

    async componentDidMount() {
        let response = await fetch(`/api/labsim/companyinitdata${window.location.search}`);
        let data = await response.json() as IInitInstitutionData;
        if (data.error)
            this.setState({
                error: `Unable to retrieve the HubSpot company data: ${data.error}. Please close and try again, or contact IT for help.`
            });
        else {
            this.setState({ loading: false, search: data.hubSpotData.name, hubSpotData: data.hubSpotData, labSimId: data.labSimId }, () => {
                this.doSearch_Click();
            });
        }
    }

    doSearch_Click() {
        this.setState({ searching: true }, async () => {
            let response = await fetch(`/api/labsim/companysearch?search=${encodeURIComponent(this.state.search || "")}`);
            let data = await response.json() as IInstitutionsResponse;
            if (data.error != null)
                this.setState({ searching: false, error: `Error while searching for any LabSim companies: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ searching: false, institutions: data.institutions });
        });
    }

    createNew_Click() {
        this.setState({ showCreateCampus: true });
    }

    removeAssignment_Click() {
        this.setState({ loading: true }, async () => {
            let q = QueryString.parse(window.location.search);
            let response = await fetch(`/api/labsim/companylink/${q.hs_object_id}`, { method: "DELETE" });
            let data = await response.json();
            if (data.error != null)
                this.setState({ error: `Error while linking to the LabSim institution: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ loading: false, completed: true, completedMessage: "HubSpot and Dynamics 365 have been updated. This HubSpot Company and the CRM Account are now unlinked and not connected to any LabSim institutions." });
        });
    }

    cancelCreation_Click() {
        this.setState({showCreateCampus: false });
    }

    doCreation_Click() {
        this.setState({ loading: true }, async () => {
            let response = await fetch(`/api/labsim/companylink/create${window.location.search}`, { method: "POST" });
            let data = await response.json() as ILinkResponse;
            if (data.error != null)
                this.setState({ showCreateCampus: false, loading: false, error: `Unable to create and link the LabSim campus: ${data.error}.<br />Please try again, or contact IT for help.` });
            else this.setState({ showCreateCampus: false, loading: false, completed: true, completedMessage: "The LabSim campus was successfully created. The HubSpot Company and CRM Account are now linked to the LabSim campus that was created." });
        });
    }

    select_Click(i: IInstitutionData) {
        this.setState({ loading: true }, async () => {
            let q = QueryString.parse(window.location.search);
            let response = await fetch(`/api/labsim/companylink`, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    hubSpotId: q.hs_object_id,
                    labSimId: i.id
                })
            });
            let data = await response.json();
            if (data.error != null)
                this.setState({ loading: false, error: `Error while linking to the LabSim institution: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ loading: false, completed: true, completedMessage: "HubSpot and Dynamics 365 have been updated. The HubSpot Company and CRM Account are now linked to the LabSim institution that was selected." });
        });
    }

    render() {
        return <div>
                   {this.state.loading && <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>}
                   {!this.state.loading && <>
                {this.state.error != null && <div className="alert alert-danger text-center" id="cAlert">
                    <label>{this.state.error}</label>
                </div>}
                {!this.state.completed && !this.state.showCreateCampus && <div className="container" id="cSearch">
                    <p>Search for an existing LabSim institution to link to this HubSpot Company, or create a new LabSim campus.</p>
                    <div className="card">
                        <div className="card-title mb-0">
                            <div className="input-group bg-light">
                                <input className="form-control" type="text" id="tbSearch" value={this.state.search} onChange={(e) => { this.setState({ search: e.target.value }) }} onKeyPress={(e) => { if (e.key == "Enter") this.doSearch_Click() }} />
                                <div className="input-group-append">
                                    <button className="btn btn-outline-secondary" type="submit" id="btnSearch" onClick={() => { this.doSearch_Click() }}>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body list-group bg-light p-4" id="dCompanies">
                            {this.state.searching && <div style={{ "textAlign": "center" }}><div className="spinner-border text-warning" style={{ "width": "2rem", "height": "2em" }} role="status"><span className="sr-only">Searching...</span></div></div>}
                            {!this.state.searching && !this.state.completed && this.state.institutions != null && <>
                                {this.state.institutions.length > 0 && <>
                                    {this.state.institutions.map((i, idx) => {
                                        return <div key={idx} className="list-group-item">
                                            <div className="float-left">
                                                <div className="d-flex align-items-center"><strong>Institution:</strong> <span className="ml-2 mr-1 h4 mb-0">{i.version == 5 ? "➎" : "➏"}</span> {i.name} <small className="ml-2">({i.institutionType})</small></div>
                                                <div><strong>Address:</strong> {i.address}, {i.city}, {i.stateOrProvince} {i.postalCode}, {i.country}</div>
                                            </div>
                                            <div className="float-right">
                                                <button className="btn btn-primary mt-3" onClick={() => { this.select_Click(i) }}>Select</button>
                                            </div>
                                        </div>
                                    })}
                                </>}
                                {this.state.institutions.length == 0 && <>No LabSim institutions were found matching the search terms.</>}
                            </>}
                        </div>
                    </div>
                    <div className="container mt-2">
                        <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelForm() }}>Cancel</button>
                        <button type="submit" className="float-right btn btn-primary ml-2" id="btnCreateNew" onClick={() => { this.createNew_Click() }}>Create a new LabSim campus</button>
                        <button type="submit" className="float-right btn btn-outline-primary" disabled={(this.state.labSimId || "") == ""} id="btnRemoveAssignment" onClick={() => { this.removeAssignment_Click() }}>Remove Assignment</button>
                    </div>
                </div>}
                {this.state.showCreateCampus && <div className="container" id="cCreateCampus">
                    <p>Create a new LabSim campus for LabSim 6?</p>
                    <div className="card-body list-group bg-light p-4" id="dNewCompany">
                        <div>
                            <div><strong>Company:</strong> {this.state.hubSpotData?.name}</div>
                            <div><strong>Address:</strong> {this.state.hubSpotData?.address}, {this.state.hubSpotData?.city} {this.state.hubSpotData?.stateOrProvince} {this.state.hubSpotData?.postalCode}, {this.state.hubSpotData?.country}</div>
                        </div>
                    </div>
                    <div className="container mt-2">
                        <button type="submit" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelCreation_Click() }}>Cancel</button>
                        <button type="submit" className="float-right btn btn-secondary" id="btnDoCreation" onClick={() => { this.doCreation_Click() }}>Create</button>
                    </div>
                </div>}
                {this.state.completed && <div className="container" id="cComplete">
                    <div className="alert alert-success" role="alert">{this.state.completedMessage}</div>
                    <button type="button" className="float-right btn btn-primary ml-2" onClick={() => { this.closeForm() }}>Done</button>
                </div>}
            </>}
               </div>;
    }
}